/**
 * Last-resort fallback for provider display when the backend catalog
 * (`GET /api/v1/conn/integrations/providers`) hasn't loaded yet or a
 * provider referenced on an existing integration is no longer in the
 * catalog. All rich metadata (description, steps, event types, docs URL)
 * is sourced from the API — see `useProviders` / `useProviderSetupGuide`.
 */
export interface ProviderFallback {
  displayName: string;
}

export function getProviderFallback(name: string): ProviderFallback {
  return {
    displayName: name.charAt(0).toUpperCase() + name.slice(1),
  };
}
